<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m8 22h2l5-8.5h5.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-5.5l-5-8.5h-2l2.5 8.5h-5.5l-1.5-2.5h-1.5l1 4-1 4h1.5l1.5-2.5h5.5z"
    />
  </svg>
</template>
